import { ShaderMaterial, Vector3, Mesh, BufferAttribute, BufferGeometry } from 'three';
import Assets from "./../assets";

const vertexShader = `
varying vec2 vUv;

uniform vec3 resolution;
uniform float aspectDiffuse;

void main() {
  vUv = uv;

  float aspect = resolution.z;
  float ratio = aspect / aspectDiffuse;
  float dir = step(1.0, ratio);
  
  vec2 responsive = vec2(mix(ratio, 1.0, dir), mix(1.0 / ratio, 1.0, 1.0 - dir));
  vUv = vUv * responsive + ((1.0 - responsive) * 0.5);

  // gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
  gl_Position = vec4( position, 1.0 );
}
`
const fragmentShader = `
varying vec2 vUv;

uniform sampler2D tDiffuse;
uniform sampler2D tDiffuse2;
uniform sampler2D disp;
uniform sampler2D perlin;

uniform float dispFactor;
uniform float effectFactor;
uniform float organic;

void main() {
  vec2 uv = vUv;

  vec4 disp = texture2D(disp, uv);
  vec4 disp2 = texture2D(perlin, uv);



  vec2 distortedPosition = vec2(uv.x + dispFactor * (sin(disp.r*effectFactor * 20.0)), uv.y - dispFactor * (cos(disp.r*effectFactor * 10.0) - 0.0));
  distortedPosition.y -= (disp2.t * organic) * dispFactor;
  vec2 distortedPosition2 =  vec2(uv.x - (1.0 - dispFactor) * (sin(disp.r*effectFactor * 20.0)), uv.y + (1.0 - dispFactor) * (cos(disp.r*effectFactor * 10.0) - 0.0));

  vec4 _texture = texture2D(tDiffuse, distortedPosition);
  vec4 _texture2 = texture2D(tDiffuse2, distortedPosition2);

  vec4 finalTexture = mix(_texture, _texture2, dispFactor);

  gl_FragColor = finalTexture;
}
`

export default class Background {
    constructor({ scene }) {
        this.scene = scene;
        this.material = new ShaderMaterial({
            uniforms: {
                tDiffuse: {
                    value: null
                },
                tDiffuse2: {
                    value: null
                },
                disp: {
                    value: null
                },
                perlin: {
                    value: null
                },
                dispFactor: {
                    value: 0
                },
                organic: {
                    value: 1
                },
                effectFactor: {
                    value: 0.05
                },
                resolution: {
                    value: new Vector3(window.innerWidth, window.innerHeight, window.innerWidth / window.innerHeight)
                },
                aspectDiffuse: {
                    value: 602.0 / 350.0
                }
            },
            vertexShader,
            fragmentShader,
            transparent: true,
        });
        this.material.uniforms.disp.value = Assets.perlin;
        this.material.uniforms.perlin.value = Assets.perlin;
        const geometry = new BufferGeometry();

        const vertices = new Float32Array([-1, 3, 0, -1, -1, 0, 3, -1, 0]);
        geometry.setAttribute('position', new BufferAttribute(vertices, 3));
        const uv = new Float32Array([0, 2, 0, 0, 2, 0]);
        geometry.setAttribute("uv", new BufferAttribute(uv, 2));

        this.mesh = new Mesh(geometry, this.material);
        this.scene.add(this.mesh)
    }

    initialize() {
    }

    handleRender() {
    }

    handleResize(width, height) {
        const ratio = width / height

        this.mesh.material.uniforms.resolution.value.x = width
        this.mesh.material.uniforms.resolution.value.y = height
        this.mesh.material.uniforms.resolution.value.z = ratio
    }

    dispose() {
    }
}